export const ROUTES = {
  // Global routes
  MAIN: "/",
  LOGIN: "/login",
  NOT_FOUND: "*",
  UNAUTHORIZED: "/unauthorized",
  UNAUTHENTICATED: "/unauthenticated",
  AUTHERROR: "/autherror",

  MANAGE_USERS: "/manage-users",
  MANAGE_USER_DETAILS: "/manage-users/:id",
  MANAGE_ROLES: "/manage-roles",
  MANAGE_API_CLIENTS: "/manage-api-clients",
  MANAGE_COST_CODES: "/manage-cost-codes",
  MANAGE_INVOICE_TYPES: "/manage-invoice-types",
  MANAGE_INVOICE_LINE_ITEMS: "/manage-invoice-line-items",
  MANAGE_WORKLOG_DEFINITIONS: "/manage-worklog-definitions",
  MANAGE_CURRENCIES: "/manage-currencies",
  MANAGE_HELIX_TEMPLATES: "/manage-helix-templates",
  MANAGE_PO_TYPES: "/manage-po-types",
  MANAGE_TEAMS: "/manage-teams",
  NOTIFICATIONS: "/notifications",
  MANAGE_APP_SETTINGS : "/manage-app-settings",
  MANAGE_EMPOWER_DEPARTMENT : "/manage-empower-departments",
  
  // Google routes
  GOOGLE_MAIN: "/google",
  GOOGLE_PROJECTS: "/google/projects",
  GOOGLE_PLPS: "/google/plps",
  GOOGLE_DOCUMENTS: "/google/documents",
  GOOGLE_LINEITEM_VAR: "/google/var",
  GOOGLE_INVOICING: "/google/invoicing",
  GOOGLE_MANUAL_PROJECTS: "/google/manual-projects",
  GOOGLE_LINGUIST_MANAGEMENT: "/google/linguist-management",
  GOOGLE_REPORTS: "/google/reports",
  GOOGLE_MY_REPORTS: "/google/my-reports",
  GOOGLE_EXTENSION_REQUESTS: "/google/extension-requests",
  GOOGLE_ADJUSTMENTS: "/google/adjustments",
  GOOGLE_QUERIES: "/google/queries",
  GOOGLE_SESAME: "/google/sesame",
  
  // Google Admin
  GOOGLE_ADMIN_PRODUCTS: "/google/manage-products",
  GOOGLE_ADMIN_PRODUCT_AREAS: "/google/manage-product-areas",
  GOOGLE_ADMIN_HELIX_TEMPLATE_MAPPINGS: "/google/manage-helix-template-mappings",
  GOOGLE_ADMIN_EXTENSION_JUSTIFICATIONS: "/google/manage-extension-justifications",
  GOOGLE_ADMIN_WORKFLOW_TYPES: "/google/manage-workflow-types",
  GOOGLE_ADMIN_QUARANTINED_PROJECTS: "/google/quarantined-projects",
  GOOGLE_ADMIN_DOWNLOAD_PROJECT: "/google/download-project",
  GOOGLE_ADMIN_FAILED_DOWNLOAD: "/google/failed-download",
  GOOGLE_ADMIN_DELAYED_STATUS_NOTIFICATION: "/google/manage-delayed-status-notification",
  GOOGLE_ADMIN_PROJECT_RATES: "/google/manage-project-rates",
  GOOGLE_ADMIN_REVIEW_HOUR_MAPPINGS: "/google/manage-review-hour-mappings",
  GOOGLE_ADMIN_SERVICES: "/google/manage-services",
  GOOGLE_ADMIN_MANAGE_TRANSLATION_HOURS: "/google/manage-translation-hour-mappings",
  GOOGLE_ADMIN_VAR_SERVICE_TYPES: "/google/manage-var-service-types",
  GOOGLE_ADMIN_LANGUAGES: "/google/manage-languages",
  GOOGLE_ADMIN_WORKFLOW_STAGES: "/google/manage-workflow-stages",
  GOOGLE_ADMIN_SHARING_CONFIGURATION: "/google/sharing-configuration",
  GOOGLE_ADMIN_PROJECT_TYPE_RULES: "/google/manage-project-type-rules",
  GOOGLE_ADMIN_COST_CODE_RULES: "/google/manage-cost-code-rules",
  GOOGLE_ADMIN_MISSING_PRODUCTS: "/google/manage-missing-products",

  // Google Dashboards
  LINGUIST_DASHBOARDS: "/google/linguist-dashboard",

  // OLiVE routes
  OLIVE_MAIN: "/olive",
  OLIVE_BATCHES: "/olive/batches",
  OLIVE_SCRIPTS: "/olive/scripts",
  OLIVE_PM_DASHBOARD: "/olive/dashboard/pm",
  OLIVE_MY_SCRIPTS: "/olive/dashboard/my-scripts",
};
